import { useState } from "react";
import { useRouter } from "../../../../../hooks/router";

import './PopUpEpisodes.scss'

import CardEpisodes from "../../../../pages_child/Episodes/CardEpisodes";

import icon_back from '../../../../SubUsers/images/back-button.png'

export default function PopUpEpisodes({
    btn_show_episodes_field,
    movie,
    stop_propogation
}) {
    const router = useRouter()
    const [activeSeasonInd, setActiveSeasonInd] = useState(0)

    const select_season_player_field = (index) => {
        setActiveSeasonInd(index)
    }

    const play_episode_player = (e) => {
        let season = movie.seasons[activeSeasonInd]
        router.push(
            `/player?type=tv_show&id=${movie.id}&season=${season.number}&episode=${e.number}`
        )
    }

    return (
        <div className="main_episodes_field" onClick={btn_show_episodes_field}>
            <img src={icon_back} className="close_field_player_movie" onClick={btn_show_episodes_field} />
            <div className="seasons_episodes_field" onClick={stop_propogation}>
                <div
                    className="seasons_field_pop_up"
                    style={movie && movie.seasons && movie.seasons.length < 8 ? { justifyContent: 'center' } : { justifyContent: 'flex-start' }}
                >
                    {movie?.seasons?.map((e, i) => {
                        return (
                            <div className={activeSeasonInd === i ? "card_season active" : "card_season"} key={e.id}
                                onClick={() => select_season_player_field(i)}>
                                <div className="arrow_seasons"></div>
                                <h2>{e.name}</h2>
                            </div>
                        )
                    })}
                </div>
                <div
                    className="episodes_field_pop_up"
                    style={movie && movie.seasons[activeSeasonInd].episodes.length < 6 ? {
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    } : null}
                >
                    {movie && movie.seasons[activeSeasonInd].episodes && movie.seasons[activeSeasonInd].episodes.length ?
                        movie.seasons[activeSeasonInd].episodes.map(elem => {
                            return <CardEpisodes play_episode_info_field={play_episode_player} key={elem.id}
                                elem={elem} />
                        }) : null
                    }
                </div>
            </div>
        </div>
    )
}